export default {"src":"/_next/static/media/logo-typo-en-white.eed13925.svg","height":272,"width":865,"blurWidth":0,"blurHeight":0};